'use strict';

var regex = "[\uD800-\uDBFF][\uDC00-\uDFFF]";

var astralRegex = function astralRegex(options) {
  return options && options.exact ? new RegExp("^".concat(regex, "$")) : new RegExp(regex, 'g');
};

module.exports = astralRegex;